import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './CategorySlider.css';
import API_BASE_URL from '../api/Config';

const Banner = ({ image, title, description, buttonLabel, productId, categoryId, bannerId, bannerData }) => {
  const navigate = useNavigate(); 

  const handleRedirect = () => {
    if (productId) {
      navigate(`/product/${productId}`);
    } else if (categoryId) {
      navigate('/categories', { state: { categoryId, clearProducts: true } }); 
    } else {
      navigate(`/banner-products/${bannerId}`, { state: { bannerData } });
    }
  };

  return (
    <div 
      className="banner-ad-component" 
      onClick={handleRedirect} 
      onTouchEnd={handleRedirect}
      style={{ cursor: 'pointer' }}
    >
      <div className="banner-content">
        <div className="banner-image">
          <img
            src={image}
            alt={`${title} - Interior Design Services & Products Nairobi Kenya`}
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/400x200';
            }}
          />
          {/* <div className="banner-gradient-overlay"></div> */}
        </div>
        <div className="banner-text">
          {/* <h2>{title}</h2>
          <p>{description}</p> */}
          <button 
            className="banner-button" 
            onClick={(e) => {
              e.stopPropagation(); 
              handleRedirect();
            }}
            onTouchEnd={(e) => {
              e.stopPropagation(); 
              handleRedirect();
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

const CategorySlider = () => {
  const [banners, setBanners] = useState([]);
  const carouselRef = useRef(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/banners`, {
          headers: {
            Accept: 'application/json',
          },
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();

        const transformedBanners = data
          .filter(banner => banner.status === 1) // Only show active banners
          .map((banner) => ({
            id: banner.id,
            title: banner.title,
            imageUrl: banner.image_fullpath || `https://admin.techieinteriors.co.ke/storage/banner/${banner.image}`,
            productId: banner.product_id || null,
            categoryId: banner.category_id || null,
            bannerType: banner.banner_type || 'primary',
            description: banner.description || 'Click for more details!',
          }));

        setBanners(transformedBanners);
      } catch (error) {
        console.error('Error fetching banners:', error);
        setBanners([]);
      }
    };

    fetchBanners();
  }, []);



  const prev = () => carouselRef.current?.prev();
  const next = () => carouselRef.current?.next();

  return (
    
    <div className="category-slider-container">
      <Carousel
        ref={carouselRef}
        effect="transition"
        autoplay
        autoplaySpeed={10000}
        dots={false}
        className="category-carousel"
        draggable={true}
        swipeToSlide={true}
        touchThreshold={5}
      >
        {/* Fetched Banners */}
        {banners.map((banner) => (
          <div key={banner.id}>
            <Banner
              image={banner.imageUrl}
              title={banner.title || 'No Title'}
              description="Click for more details!"
              buttonLabel={banner.productId ? "Shop now" : "View More"}
              productId={banner.productId}
              categoryId={banner.categoryId}
              bannerId={banner.id}
              bannerData={banner}
            />
          </div>
        ))}
      </Carousel>

      <span onClick={prev} className="scroll-button left">
        <LeftOutlined />
      </span>
      <span onClick={next} className="scroll-button right">
        <RightOutlined />
      </span>
    </div>
  );
};

export default CategorySlider;